import { render, staticRenderFns } from "./submitreport.vue?vue&type=template&id=07275839&scoped=true"
import script from "./submitreport.vue?vue&type=script&lang=js"
export * from "./submitreport.vue?vue&type=script&lang=js"
import style0 from "./submitreport.vue?vue&type=style&index=0&id=07275839&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07275839",
  null
  
)

export default component.exports